module.exports = "<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\">\n    <div class=\"col-lg-10\">\n        <h2>Lead Gen Dashboard</h2>\n        <ol class=\"breadcrumb\">\n            <li>\n                Home\n            </li>\n        </ol>\n    </div>\n    <div class=\"col-lg-2\">\n\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/dashboard/dashboard.template.html
// module id = 1427
// module chunks = 9